export default __webpack_public_path__ + "static/media/bookingcal.a6ea6a42.svg";